export interface Policy {
  id: number;
  name: string;
  umr: string;
  inceptionDate: string;
  expiryDate: string;
  renewalDate: string;
  cancellationDate: string | null;
  replacedDate: string | null;
  classOfBusinessId: number;
  riskReference: string;
  riskDescription: string | null;
  riskCountry: string;
  createdDate: string;
  updatedDate: string;
  lastViewedDate: string | null;
  policyClients: [PolicyClient];
  specialistUserId: string | null;
  documentFolderId: number;
  isDeleted: boolean;
  portalId: number;
  renewalStatus: PolicyRenewalStatus;
  status: PolicyStatus;
  additionalData?: any;
}

export type PolicyLite = Pick<
  Policy,
  | 'classOfBusinessId'
  | 'expiryDate'
  | 'id'
  | 'inceptionDate'
  | 'isDeleted'
  | 'name'
  | 'policyClients'
  | 'status'
>;

export enum PolicyStatus {
  Inactive,
  Active,
  Pending,
  Mta,
  Initialized = 4,
  Expired = -2,
  Cancelled = -3,
  Defunct = -1,
}

export interface PolicyClient {
  id: number;
  insuredName: string;
}

// POST
export type PolicyCreate = Omit<
  Policy,
  | 'id'
  | 'createdDate'
  | 'updatedDate'
  | 'lastViewedDate'
  | 'policyClients'
  | 'isDeleted'
  | 'documentFolderId'
  | 'portalId'
  | 'renewalStatus'
  | 'status'
  | 'cancellationDate'
  | 'replacedDate'
> & {
  clientId: number;
};

// PUT
export type PolicyUpdate = PolicyCreate & {
  id: number;
};

export const POLICY_RENEWAL_STATUS = {
  Active: 1,
  RenewalUpcoming: 2,
  RenewalImminent: 3,
  Expired: 4,
} as const;

export type PolicyRenewalStatus =
  (typeof POLICY_RENEWAL_STATUS)[keyof typeof POLICY_RENEWAL_STATUS];

export enum POLICY_ACTION {
  NotTakenUp,
}

export type PolicyAction = (typeof POLICY_ACTION)[keyof typeof POLICY_ACTION];
